import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Client-side config for the live Tomitra Firebase project (tomitra-prod).
// These are NOT secrets — public by design. Security lives in the backend
// admin allowlist (ADMIN_EMAILS) which verifies the Firebase ID token; the
// backend also verifies tokens against tomitra-prod, so the admin app MUST
// authenticate here (not the dead tomitra-app project).
// apiKey is the project's unrestricted browser/Android key (shared with the
// mobile google-services.json). Firebase Auth needs only apiKey/authDomain/
// projectId; appId is optional and omitted (no web app registered yet).
const firebaseConfig = {
  apiKey: "AIzaSyBDS5Tou-C5HzUSuKUfM-Ma5jphJhntFfc",
  authDomain: "tomitra-prod.firebaseapp.com",
  projectId: "tomitra-prod",
  messagingSenderId: "187545700403",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
